import Immutable from 'immutable';
import React from 'react';
import CheckBoxPane from '../../forms/checkboxpane';

const EMPTY_LIST = Immutable.List([]);

const identity = value => value;

export default function CheckBoxPaneDefinition(name) {
	if (!(this instanceof CheckBoxPaneDefinition)) {
		return new CheckBoxPaneDefinition(name);
	}

	let isRootPath = false;
	let path = name;
	let isVisibleCallback;
	let isHidden;
	let valueToItems = identity;
	let itemsToValue = identity;
	let large = false;
	let columnCount;
	let label;
	let radio;

	this.setLabel = function(value) {
		label = value;
		return this;
	};

	this.setRadio = function(value) {
		radio = value;
		return this;
	};

	this.setPath = function(value) {
		isRootPath = false;
		if (Array.isArray(value)) {
			if (value[0] === '/') {
				value = value.slice(1);
				isRootPath = true;
			}
		}
		path = value;
		return this;
	};

	this.setLarge = function(value) {
		large = value;
		return this;
	};

	this.setColumnCount = function(value) {
		columnCount = value;
		return this;
	};

	const getValue = function(ctx) {
		return isRootPath ? ctx.getRootProperty(path) : ctx.getProperty(path);
	};

	const setValue = function(ctx, value) {
		if (isRootPath) {
			ctx.setRootProperty(path, value);
		} else {
			ctx.setProperty(path, value);
		}
	};

	this.setVisible = function(value) {
		if (typeof value === 'function') {
			isHidden = false;
			isVisibleCallback = value;
		} else {
			isHidden = !value;
			isVisibleCallback = null;
		}
		return this;
	};

	this.setValueToItems = function(value) {
		valueToItems = value || identity;
		return this;
	};

	this.setItemsToValue = function(value) {
		itemsToValue = value || identity;
		return this;
	};

	this.validateAll = function(ctx, errors) {

	};

	this.render = function(ctx, key = 0) {
		if (isHidden || (isVisibleCallback && !isVisibleCallback(ctx))) {
			return null;
		}
		const value = getValue(ctx);
		return (
			<CheckBoxPane
				key={key}
				items={valueToItems(value, ctx)}
				large={large}
				columnCount={columnCount}
				label={label}
				radio={radio}
				onChange={items => {
					setValue(ctx, itemsToValue(items, value, ctx));
				}}
			/>
		);
	};
}

